import { Divider, DividerProps } from 'antd';

export type DividerAtomProps = DividerProps;

const DividerAtom = Divider;

export default DividerAtom;
